// This file need to be removed or changed once we get global styles
// for switch checkbox from lakshmi and team
import styled from 'styled-components';
export const StyledCheckBoxDiv = styled.div`
  width: auto;
`;
